import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import { ZINDEX } from '../../constants';
import CheckButton from './check-button';
import LoadingIndicator from './loading-indicator';

const useStyles = createUseStyles({
  bigbutton: {
    '&.bottomleft': { bottom: 12, left: 12 },
    '&.bottomright': { bottom: 12, right: 12 },
    '&.topleft': { left: 12, top: 12 },
    '&.topright': { right: 12, top: 12 },
    composes: ['is-absolute'],
    zIndex: ZINDEX.MAP_CONTROLS,
  },
  wrapper: {
    composes: ['is-relative', 'flex-rows', 'flex-end', 'items-center'],
  },
});

const BigButtonComponent = React.memo(({ position }) => {
  const classes = useStyles();
  const loading = useSelector(_ => _.loading);

  return (
    <div
      className={classnames(classes.bigbutton, {
        bottomleft: position === 'bottomleft',
        bottomright: position === 'bottomright',
        topleft: position === 'topleft',
        topright: position === 'topright',
      })}>
      <div className={classes.wrapper}>
        {loading && <LoadingIndicator />}
        <CheckButton />
      </div>
    </div>
  );
});

BigButtonComponent.defaultProps = {
  position: 'bottomright',
};

BigButtonComponent.propTypes = {
  position: PropTypes.oneOf([
    'topleft',
    'bottomleft',
    'bottomright',
    'topright',
  ]),
};

BigButtonComponent.displayName = 'BigButtonComponent';

export default BigButtonComponent;
